/**
 * Generic confirm dialog. Render conditionally — caller controls visibility.
 * For "publish with note" use AdminPublishModal instead.
 */

import type { ReactNode } from 'react';

interface Props {
  title: string;
  body: ReactNode;
  confirmLabel: string;
  confirmVariant: 'danger' | 'primary';
  onCancel(): void;
  onConfirm(): void;
}

export function AdminModal({
  title,
  body,
  confirmLabel,
  confirmVariant,
  onCancel,
  onConfirm,
}: Props) {
  const confirmClass =
    confirmVariant === 'danger' ? 'adm-btn adm-btn--danger' : 'adm-btn adm-btn--primary';
  return (
    <div className="adm-modal-bg" role="dialog" aria-modal="true" aria-labelledby="adm-modal-title">
      <div className="adm-modal">
        <h3 id="adm-modal-title">{title}</h3>
        <p>{body}</p>
        <div className="adm-modal__actions">
          <button className="adm-btn adm-btn--ghost" type="button" onClick={onCancel}>
            Cancel
          </button>
          <button className={confirmClass} type="button" onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
